import React from 'react';
import { useTranslation } from 'react-i18next';
import { Category } from '../../features/categories/categoryModels';
import './CategoriesGrid.css';

interface CategoriesGridProps {
  categories: Category[];
  onCategoryClick: (categoryId: string) => void;
}

const CategoriesGrid: React.FC<CategoriesGridProps> = ({ categories, onCategoryClick }) => {
  const { t } = useTranslation();
  const sortedCategories = [...categories].sort((a, b) => a?.categoryOrder - b?.categoryOrder);
  return (
    <div className="categories-grid">
      {sortedCategories.map((category: Category, index: number) => (
        <div
          key={category._id}
          className="category-card"
          onClick={() => onCategoryClick(category._id)}
          style={{
            animationDelay: `${index * 0.1}s`
          }}
        >
          {/* Category Image */}
          <div className="category-image-wrapper">
            <img
              src={category.imagePath || '/placeholder-category.jpg'}
              alt={category.categoryName}
              className="category-image"
              onError={(e) => {
                e.currentTarget.src = '/placeholder-category.jpg';
              }}
            />
            <div className="category-overlay"></div>
          </div>

          {/* Category Info */}
          <div className="category-info">
            <h3 className="category-name">{category.categoryName}</h3>
            <div className="category-meta">
              <span className="product-count">
                {category.productCount || 0} {t('categories.products')}
              </span>
              <span className="view-arrow">→</span>
            </div>
          </div>

          {/* Hover Effect */}
          <div className="category-glow"></div>
        </div>
      ))}
    </div>
  );
};

export default CategoriesGrid;
